import { title } from "assets/jss/hwblog.js";

const productStyle = {
  section: {
    padding: "70px 0",
    textAlign: "left"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  description: {
    color: "#999"
  },
  snippet: {
    fontSize: "16px"
  }
};

export default productStyle;
